import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";

// Mismos colores que el pill de estatus en la tabla (estiloEstatus): R=verde, P=amarillo
const COLOR_PROGRAMADA = "#eab308";
const COLOR_REALIZADA = "#1e5b34";

// Barra apilada por asesor: "realizadas" abajo, "restantes" (programadas - realizadas) arriba —
// visualmente la barra se va llenando de programada -> realizada, igual que el indicador de Zoho.
// Un click en cualquiera de los dos segmentos de la barra de un asesor despliega (o cierra) ese
// mismo asesor en la tabla de abajo, vía onAsesorClick.
export const ReporteVisitasGrafica = ({ datos, onAsesorClick }) => {
  const data = (Array.isArray(datos) ? datos : []).map((d) => ({
    idvendedor: d.idvendedor,
    asesor: d.vendedor,
    realizadas: d.realizadas,
    restantes: Math.max(0, d.programadas - d.realizadas),
    programadas: d.programadas,
  }));

  const handleClick = (payload) => {
    if (payload?.idvendedor != null) onAsesorClick?.(payload.idvendedor);
  };

  return (
    <div className="rv-grafica">
      <div className="rv-grafica-titulo">Visitas por asesor</div>
      <ResponsiveContainer width="100%" height={320}>
        <BarChart data={data} margin={{ top: 4, right: 20, left: 0, bottom: 30 }} barCategoryGap="20%" maxBarSize={64}>
          <CartesianGrid vertical={false} stroke="#e8ecf0" />
          <XAxis
            dataKey="asesor"
            tick={{ fontSize: 11, fill: "#64748b" }}
            angle={-25}
            textAnchor="end"
            interval={0}
            height={60}
          />
          <YAxis tick={{ fontSize: 11, fill: "#64748b" }} allowDecimals={false} />
          <Tooltip
            formatter={(value, name) => [value, name === "realizadas" ? "Realizadas" : "Programadas restantes"]}
            labelStyle={{ fontWeight: 700, color: "#1a2332" }}
            contentStyle={{ borderRadius: 8, border: "1px solid #e8ecf0", fontSize: 12.5 }}
          />
          <Legend
            formatter={(value) => (value === "realizadas" ? "Realizada" : "Programada")}
            verticalAlign="top"
            align="right"
            wrapperStyle={{ fontSize: 12.5, top: -14 }}
          />
          <Bar
            dataKey="realizadas"
            stackId="visitas"
            fill={COLOR_REALIZADA}
            radius={[0, 0, 0, 0]}
            cursor="pointer"
            onClick={(e) => handleClick(e?.payload)}
          >
            <LabelList dataKey="realizadas" position="inside" fill="#fff" fontSize={11} fontWeight={700} />
          </Bar>
          <Bar
            dataKey="restantes"
            stackId="visitas"
            fill={COLOR_PROGRAMADA}
            radius={[4, 4, 0, 0]}
            cursor="pointer"
            onClick={(e) => handleClick(e?.payload)}
          >
            <LabelList dataKey="programadas" position="top" fill="#1a2332" fontSize={11} fontWeight={700} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
